var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('house-funds-form',{attrs:{"loading":_vm.isSendingData},on:{"submit":function (data) { return _vm.createHouseFund(data); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }